export default "__VITE_ASSET__x5jplkE6__"